import { createReducer, on } from '@ngrx/store';
import { DeviceAssignmentHistoryApiActions } from './device-assignment-history.actions';
import { adapter, initialState } from './device-assignment-history.state';

export const deviceAssignmentHistoryReducer = createReducer(
  initialState,
  on(DeviceAssignmentHistoryApiActions.historyLoaded, (state, { history, udid }) =>
    adapter.upsertOne(
      {
        deviceId: udid,
        history: history,
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceAssignmentHistoryIds = selectIds;

export const selectDeviceAssignmentHistoryEntities = selectEntities;

export const selectAllDeviceAssignmentHistory = selectAll;
